import { Plus } from '@styled-icons/boxicons-regular';
import { DreamBlock } from '@typedream/core';
import { findNodePath, getLastChildPath } from '@udecode/plate-core';
import { Path } from 'slate';
import styled from 'styled-components';
import { DreamEditor } from '../../../types';
import { addAccordionItem } from '../transforms';

const StyledAddAccordionItemButton = styled.div`
  all: unset;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
  background-color: var(--accent);
  padding: 8px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
  z-index: 1;
  color: white;
  cursor: pointer;
  pointer-events: initial;
  transition: opacity 0.2s, visibility 0.2s;
`;

function AddAccordionItemButton(props: {
  editor: DreamEditor,
  element: DreamBlock,
}) {
  const { editor, element } = props;

  const onAddItem = () => {
    const path = findNodePath(editor, element);
    if (!path) return;
    if (element.type === 'accordion_item') {
      addAccordionItem(editor, Path.next(path));
    }
    const lastChildPath = getLastChildPath([element, path]);
    addAccordionItem(editor, Path.next(lastChildPath));
  };

  return (
    <StyledAddAccordionItemButton role="none" onClick={onAddItem}>
      <Plus size={24} />
    </StyledAddAccordionItemButton>
  );
}
export default AddAccordionItemButton;
